'use strict';

angular.module('openhomesController', ['ngSanitize'])
.controller('OpenHomesController', ['appInfo', '$scope', '$rootScope', '$log', '$location', '$window', 'BuyerService', 'CommonService',
    function (appInfo, $scope, $rootScope, $log, $location, $window, BuyerService, CommonService ) {    
    
      $scope.page = 'openHomes';
      $scope.activeAgency = $rootScope.currentUser.activeAgency;
      $scope.openHomes = [{}];
      $scope.propertyRefs = [];
      $scope.propertyMicrositeURL = {};

      $scope.watchlist = [];

      $scope.enquiry = {};
      $scope.propertyDetail = {};
      $scope.openHomeDetail = {};
      
      $scope.currentPageSection = 'main';  //can be propertyDetail, enquiryForm depending upon what section is displayed
      $scope.previousPageSection = 'main';
      $scope.showWeeklyRentReturn = false;

      var loadUpcomingOpenHomes = function() {
      var upstreamCall = true;
      if(!$rootScope.loading) {
          $rootScope.loading = true;
          upstreamCall = false;
      }

        
      BuyerService.getUpcomingOpenHomes()
        .then(function(data) {
            $scope.openHomes = data;
            return BuyerService.getWatchlist();
        })
        .then(function(data) {
            $scope.watchlist = data;
            angular.forEach($scope.openHomes, function(oh) {
                var property = oh.property[0];
                if(property) {
                    $scope.propertyRefs.push(property.propertyRef);
                    var index = CommonService.indexByField($scope.watchlist, 'propertyId', property.propertyId);
                    if(index > -1) {
                        property.watched = true;
                        property.watchlistId = $scope.watchlist[index].id;
                    } else {
                        property.watched = false;
                        property.watchlistId = 0;
                    }
                }
                
            });
            return BuyerService.getPropertyMicrositeURL($scope.propertyRefs);  
        })
        .then(function(data) {
            $scope.propertyMicrositeURL = data;
        })
        .catch(function(err) {
            console.log(err);
        })
        .finally(function(data) {
            // loadPreferences();
            if (!upstreamCall) {
                $rootScope.loading = false;
            }
            
        });
      }

    $scope.addToWatchlist = function(property) {
        $rootScope.loading = true;
        BuyerService.addToWatchlist(property.propertyId)
        .then(function(data){
            property.watched = true;
            property.watchlistId = data;
            // loadProperties();
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(err){
            $rootScope.loading = false;
        })
    }

    $scope.removeFromWatchlist = function(property) {
        $rootScope.loading = true;
        BuyerService.removeFromWatchlist(property.watchlistId)
        .then(function(data){
            property.watched = false;
            property.watchlistId = 0;
            // loadProperties();
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(err){
            $rootScope.loading = false;
        })
    }

    

    var init = function() {
      loadUpcomingOpenHomes();
    }

    $scope.displayPageSection =  function(section) {
      return (section == $scope.currentPageSection);
    }

    $scope.showPageSection = function(openHome, section) {
        $scope.page = section;
        $scope.previousPageSection = $scope.currentPageSection;
        $scope.currentPageSection = section;
        $scope.propertyDetail = openHome.property[0];
        $scope.openHomeDetail = openHome;
    }

    $scope.hidePageSection = function() {
        var previousPage = $scope.currentPageSection;
        $scope.page = 'openHomes';
        $scope.currentPageSection = $scope.previousPageSection;
        $scope.previousPageSection = previousPage;
        $scope.propertyDetail = {};
        $scope.openHomeDetail = {};
    }

    $scope.displayWeeklyRentReturn = function(property) {
        var propertyAddress = property.streetUnit + ' '  + property.streetRef + ' ' + property.streetName + ' ' + property.streetType; 
        var noteText = "Buyer clicked approximate rent return for the property: " + propertyAddress;
        BuyerService.addNote(noteText)
        .then(function(data){
            $scope.showWeeklyRentReturn = true;
            $scope.weeklyRentReturn = property.weeklyRentReturn;    
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(data){

        });
    }

    $scope.getPropertyURL = function(propertyRef) {
        var propertyURL = 'http://www.wiseberry.com.au/property/' + propertyRef;
        if($scope.propertyMicrositeURL[propertyRef]) {
            propertyURL = $scope.propertyMicrositeURL[propertyRef];
        }
        return propertyURL;
    }

    init();

}]);